import React, {Component} from "react";
import ReactDOM from "react-dom";
import App from "../../index.js";
import "../../../fiat.css"
import { config } from "../../../configs/fiat"
import loaderSvg from "../../../images/fiat-loading.svg";


const brand =  {
    value: "fiat",
    id: [8,9,6],
    division : "2",
    name : "Fiat",
    website : "https://www.fiat.com.au",

};

function FiatApp(props){
    return (
        <App brand={brand} formName={"fca-fiat-cu"} config={config} loader={loaderSvg}/>
    )
}

ReactDOM.render(<FiatApp/>,document.getElementById("root"));
